export default __webpack_public_path__ + "static/media/golf.7feeb463.JPG";